import { render, staticRenderFns } from "./memberClass.vue?vue&type=template&id=1a7b9921&scoped=true&"
import script from "./memberClass.vue?vue&type=script&lang=js&"
export * from "./memberClass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a7b9921",
  null
  
)

export default component.exports